import { render, staticRenderFns } from "./VTaskProgress.vue?vue&type=template&id=2ec9fa66&"
import script from "./VTaskProgress.vue?vue&type=script&lang=js&"
export * from "./VTaskProgress.vue?vue&type=script&lang=js&"
import style0 from "./VTaskProgress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports